export default __webpack_public_path__ + "static/media/3.a7dbc6fd.jpg";